export default class Group {
  constructor () {
    this.id = 0
    this.groupname = ''
    this.options = 0
    this.description = ''
  }
}
